import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/reservedindex/:id?',
    name: 'ReservedIndex',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/ReservedIndex.vue'),
    meta: {
      title: '首頁',
      level: 2
    },
  },
  {
    path: '/reservedlist/:id?',
    name: 'ReservedList',
    component: () => import('../views/ReservedList.vue'),
    meta: {
      title: '預約列表',
      level: 2,
      requiresAuth: true
    },
  },
  {
    path: '/orderrecord/:id?',
    name: 'OrderRecord',
    component: () => import('../views/OrderRecord.vue'),
    meta: {
      title: '交易紀錄',
      level: 2
    },
  },
  {
    path: '*',
    name: 'Home',
    component: Home
  },
]

const router = new VueRouter({
  routes
})

export default router